// extracted by mini-css-extract-plugin
export default {"container":"PasswordText_container__W1UgG"};